var map = {
	"./Inactive_agencies.svg": 2699,
	"./active_agencies.svg": 2700,
	"./agency_manager.svg": 2701,
	"./b_files.svg": 2702,
	"./dashboard.svg": 2703,
	"./dedicated_agency.svg": 2704,
	"./dnc_users.svg": 2705,
	"./email_content.svg": 2706,
	"./last_login.svg": 855,
	"./locked_users.svg": 2707,
	"./manage_customers.svg": 2708,
	"./manage_schedulers.svg": 2709,
	"./manage_users.svg": 2710,
	"./notification_bell.svg": 2711,
	"./onboard_agencies.svg": 2712,
	"./onboard_b_files.svg": 2713,
	"./profile.svg": 2714,
	"./question-circle.svg": 2715,
	"./relegion_stats.svg": 2716,
	"./reward_points.svg": 2717,
	"./search_staff.svg": 2718,
	"./stats.svg": 2719,
	"./stats_by_agency.svg": 2720,
	"./tango_account.svg": 2721,
	"./training_library.svg": 2722,
	"./training_library_upload.svg": 2723,
	"./updated_manage_users.svg": 2724,
	"./updated_training_library.svg": 2725,
	"./upload_customers.svg": 2726,
	"./upload_dnc.svg": 2727
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2698;


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons ^\.\/.*\.svg$
// module id = 2698
// module chunks = 0